import React from 'react';
import express from '../../media/skills/express.png';
import tailwind from '../../media/skills/tailwind.png';
import mu from '../../media/skills/mu.png';

const Skills = () => {

    return (
        <div>
            <h1 className="text-gray-600 text-3xl text-center pt-16 font-bold tracking-wider my-16">Skills</h1>
            <section>
                <div data-aos="zoom-in" className="grid  md:grid-cols-3 sm:grid-cols-2 grid-cols-1  md:mx-36 gap-8 md:gap-y-20">
                    <div className="flex mx-auto">
                        <i className="fab fa-react text-7xl border-r-2 pr-3  "></i>
                        <article className="ml-3">
                            <h2 className="text-2xl">React</h2>
                            <p>Intermediate</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <i className="fab fa-js-square text-7xl border-r-2 pr-3  "></i>
                        <article className="ml-3">
                            <h2 className="text-2xl">JavaScript</h2>
                            <p>Intermediate</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <i className="fab fa-html5 text-7xl border-r-2 pr-3  "></i>
                        <article className="ml-3">
                            <h2 className="text-2xl">HTML</h2>
                            <p>Intermediate</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <i className="fab fa-css3 text-7xl border-r-2 pr-3  "></i>
                        <article className="ml-3">
                            <h2 className="text-2xl">CSS</h2>
                            <p>Intermediate</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <img src={express} className="w-24 border-r-2 pr-3 " alt="" />
                        <article className="ml-3">
                            <h2 className="text-2xl">Express.js</h2>
                            <p>Intermediate</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <i className="fab fa-node text-7xl border-r-2 pr-3  "></i>
                        <article className="ml-3">
                            <h2 className="text-2xl">Node.js</h2>
                            <p>Basic</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <img src={tailwind} className="w-24 border-r-2 pr-3 " alt="" />
                        <article className="ml-3">
                            <h2 className="text-2xl">Tailwind</h2>
                            <p>Intermediate</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <i className="fab fa-bootstrap text-7xl border-r-2 pr-3  "></i>
                        <article className="ml-3">
                            <h2 className="text-2xl">Bootstrap</h2>
                            <p>Intermediate</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <img src={mu} className="w-24 border-r-2 pr-3 " alt="" />
                        <article className="ml-3">
                            <h2 className="text-2xl">Material UI</h2>
                            <p>Intermediate</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <i className="fab fa-python text-7xl border-r-2 pr-3  "></i>
                        <article className="ml-3">
                            <h2 className="text-2xl">Python</h2>
                            <p>Intermediate</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <img src="https://cdn4.iconfinder.com/data/icons/logos-brands-5/24/mongodb-512.png" className="w-24 border-r-2 pr-3 " alt="" />
                        <article className="ml-3">
                            <h2 className="text-2xl">MongoDB</h2>
                            <p>Basic</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <i className="fab fa-cuttlefish text-7xl border-r-2 pr-3  "></i>
                        <article className="ml-3">
                            <h2 className="text-2xl">C Language</h2>
                            <p>Intermediate</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <img src="https://img.icons8.com/ios/452/c-sharp-logo.png" className="w-24 border-r-2 pr-3 " alt="" />
                        <article className="ml-3">
                            <h2 className="text-2xl">C Sharp</h2>
                            <p>Basic</p>
                        </article>
                    </div>
                    <div className="flex mx-auto">
                        <i className="fas fa-database text-7xl border-r-2 pr-3  "></i>
                        <article className="ml-3">
                            <h2 className="text-2xl">My SQL</h2>
                            <p>Beginner</p>
                        </article>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Skills;